<script>

import ProductBrandItemComp from './ProductBrandItem';
import { productListMethods, productListComputed, layoutMethods, exportMethods,erpFixMessages, erpUserRolesMethods } from "@/state/helpers";
import Swal from "sweetalert2";
import ImageUpload from '@/components/ImageUpload';
import { required } from "vuelidate/lib/validators";
import { getModuleAccess } from '@/router/helper.js'

/**
 * Product brand component
 */
export default {
  page: {
    title: "Product Brand"
  },
  data() {
    return {
      title: "Product Brand",
      items: [],
      folder: 'product-brands',
      brandLogo: {
        filename: null,
        type: null,
        base64: null
      },
      pagination: {
        rows: 12,
        page: 1,
        keyword: '',
        field: 'all',
        sort: 'name',
        orderDesc: false,
      },
      pageOptions: [12, 24, 36, 48, 60, 72, 84, 96, 108, 120],
      editModal: false,
      createModal: false,
      productBrandItem: {
        productId: null,
        productBrandName: '',
        productBrandDesc: ' ',
        productBrandImageSrc: ' '
      },
      formExitChecker: {
        productId: null,
        productBrandName: '',
        productBrandDesc: ' ',
        productBrandImageSrc: ' '
      },
      searchValue: {
        keyword: "",
      },
      searchOptions: [
        { text: 'Search All', value: 'all' },
        { text: 'Product Brand', value: 'name' },
        { text: 'Brand Description', value: 'description' },
      ],
      lookupParams: {
        field: 'all',
      },
      sortOrderOptions: [
        { text: 'ASC', value: false },
        { text: 'DESC', value: true }
      ],
      orderFieldOptions: [
        { text: 'Product Brand', value: 'name' },
        { text: 'Brand Description', value: 'description' },
      ],
      oldKeyword: '',
      productBrandModule: {
        access: {
          create: true,
          read: true,
          update: true,
          delete: true
        }
      }
    };
  },
  validations: {
    productBrandItem: {
      productBrandName  : {required},
      productBrandDesc  : {required},
    },
  },
  components: {
    'product-brand-item': ProductBrandItemComp,
    ImageUpload
  },
  computed: {
    ...productListComputed,
    ...erpFixMessages
  },
  methods: {
    ...layoutMethods,
    ...productListMethods,
    ...exportMethods,
    ...erpUserRolesMethods,
    async onExport(){
      var self = this;
      await this.onSearch().then(function(){
        console.log("check this:",self.brandTotalRows);
        if(self.brandTotalRows ==0 ){
          Swal.fire("Failed!", self.exportNullPrompt, "warning");
        }else{
          let params = Object.assign(
            self.pagination, 
            self.lookupParams, 
            {
              module: 'product_brands',
              email: JSON.parse(localStorage.getItem('userData')).email
            });

          delete params.page;
          delete params.rows;
          
          self.exportReport(params)
            .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
            .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
        }
      });
    },
    async refresh() {
      this.pagination.page = 1;
      this.clearSearch();
      await this.populateProductBrands();
    },
    openCreateModal() {
      this.clearSearch();
      this.clearCategory();
      this.clearLogo();
      this.createModal = true;
    },
    async populateProductBrands() {
      await this.onPageUpdate();
      // this.listProductBrands(this.pagination);

    },
    createProdBrand() {
      var brandObj = { ...this.productBrandItem };
      delete brandObj.productId;

      if (this.brandLogo.base64) {
        var brandLogo = { ...this.brandLogo };
        brandLogo.folder = this.folder;

        this.uploadLogo(brandLogo)
          .then((imageKey) => {
            brandObj = {
              ...brandObj,
              productBrandImageSrc: imageKey
            }

            this.create(brandObj);
          })
          .catch((err) => {
            Swal.fire("Upload Failed!", `${err}`, "error");
          });
      } else {
        this.create(brandObj);
      }
    },
    editProdBrand(productBrand) {
      if (!this.productBrandModule.access.read && !this.productBrandModule.access.update) {
        Swal.fire(
          "Access Restricted",
          "Looks like your access is limited. Please contact your administrator.",
          "warning"
        );
      } else {
        this.editModal = true;
        this.productBrandItem = {
          productId: productBrand.productId,
          productBrandName: productBrand.productBrandName,
          productBrandDesc: productBrand.productBrandDesc,
          productBrandImageSrc: productBrand.productBrandImageSrc
        };
        this.formExitChecker = {
          productId: productBrand.productId,
          productBrandName: productBrand.productBrandName,
          productBrandDesc: productBrand.productBrandDesc,
          productBrandImageSrc: productBrand.productBrandImageSrc
        };
      }
    },
    saveProdBrand() {
      var brandObj = { ...this.productBrandItem };
      delete brandObj['productBrandImageSrc'];

      if (this.brandLogo.base64) {
        var brandLogo = { ...this.brandLogo };
        brandLogo.folder = this.folder;

        this.uploadLogo(brandLogo)
          .then((imageKey) => {
            brandObj = {
              ...brandObj,
              productBrandImageSrc: imageKey
            }
            this.update(brandObj);
          })
          .catch((err) => {
            Swal.fire("Upload Failed!", `${err}`, "error");
          });
      } else {
        this.update(brandObj);
      }
    },
    deleteProdBrand(productBrand) {
      if (!this.productBrandModule.access.delete) {
        Swal.fire(
          "Access Restricted",
          "You are not allowed to delete a Product Brand.",
          "warning"
        );
      } else {
        Swal.fire({
          title: "Are you sure?",
          text: `Do you really want to delete ${productBrand.productBrandName}? This process cannot be undone.`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: "Yes",
          cancelButtonText: 'No'
        }).then((result) => {
          if (result.isConfirmed) {
            console.log(productBrand)
            this.deleteProductBrand(productBrand.productId)
              .then(() => {
                Swal.fire("Delete Successful!", `${productBrand.productBrandName} has been deleted.`, "success");
                this.populateProductBrands();
              })
              .catch((e) => {
                Swal.fire("Delete Failed!", `An Error Occured: ${e}`, "danger");
              });
          } else {
            return;
          }
        });
      }
    },
    create(brandObj) {
      this.$v.$touch();
      if (!this.$v.productBrandItem.$invalid){
        this.createProductBrand(brandObj)
        .then(() => {
          this.createModal = false;
          Swal.fire("Create Successful!", `${brandObj.productBrandName} has been created.`, "success");
          this.populateProductBrands();
          this.clearLogo();
        })
        .catch((err) => {
          this.createModal = false;
          Swal.fire("Create Failed!", (err.message? err.message:`${brandObj.productBrandName} was not created.`), "error");
          this.clearLogo();
        });
      }
    },
    update(brandObj) {
      this.$v.$touch();
      if (!this.$v.productBrandItem.$invalid){
        this.updateProductBrand(brandObj)
        .then(() => {
          this.editModal = false;
          Swal.fire("Update Successful!", `${brandObj.productBrandName} has been updated.`, "success");
          this.populateProductBrands();
          this.clearLogo();
        })
        .catch((err) => {
          this.editModal = false;
          Swal.fire("Update Failed!", (err.message? err.message:`${brandObj.productBrandName} was not updated.`), "error");
          this.clearLogo();
        });
      }
    },
    clearLogo() {
      this.brandLogo = {
        filename: null,
        type: null,
        base64: null
      }
    },
    clearCategory() {
      this.productBrandItem = {
        productId: null,
        productBrandName: '',
        productBrandDesc: '',
        productBrandImageSrc: ' '
      }
      this.formExitChecker = {
        productId: null,
        productBrandName: '',
        productBrandDesc: '',
        productBrandImageSrc: ' '
      }
    },
    clearSearch() {
      this.searchValue = {
        keyword: ""
      }
    },
    async onSearch() {
      if (this.searchValue.keyword) {
        this.pagination.page = 1;
        this.searching = true
        this.oldKeyword = this.searchValue.keyword
        await this.searchProduct()
      } else {
        if (this.oldKeyword != '') {
          this.pagination.page = 1;
          this.searching = true
          await this.searchProduct()
        }
        else {
          this.searching = false
          this.searchValue = {
            keyword: "",
          }
          await this.onPageUpdate();
          // this.listProductBrands()
        }
      }
    },
    async searchProduct() {
      var filter = Object.assign(this.pagination, this.lookupParams);
      var params = Object.assign(filter, this.searchValue);
      await this.listProductBrands(
        params
      )
    },
    async onPageUpdate() {
      if (this.searching) {
        await this.searchProduct()
      } else {
        await this.listProductBrands(this.pagination)
      }
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    leaveform(modal = 'add') {
      if (JSON.stringify(this.productBrandItem) == JSON.stringify(this.formExitChecker)) {
        if (modal == 'add') {
          this.createModal = false;
        } else if (modal == 'edit') {
          this.editModal = false;
        }
        this.clearCategory();
        return;
      }
      Swal.fire({
        title: 'Are you sure?',
        text: "you want to leave this page?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '##804997',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.isConfirmed) {
          if (modal == 'add') {
            this.createModal = false;
          } else if (modal == 'edit') {
            this.editModal = false;
          }
          this.clearCategory();
        } else {
          return;
        }
      })
    }
  },
  async mounted() {
    await this.populateProductBrands();
    this.changeTitle({ title: 'Product Brand' });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home' } },
        { text: 'Product Listing', to: { name: 'Product' } },
        { text: 'Product Brand', to: { name: 'Product Brand' } }
      ]
    });

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess('Utilities', 'Product Template', 'Product Brand')
        .then((access) => this.productBrandModule.access = access);
  }
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-4 col-sm-4">
                <div class="my-2">
                  <h5 class="card-title text-dark">
                    <span class="fw-normal ms-lg-2">{{ brandTotalRows }}</span> Record(s)
                  </h5>
                </div>
                <!-- <form class="d-flex " @submit.prevent="onSearch()">
                    <b-input-group>
                      <b-form-input
                        class="rounded-0"
                        v-model="searchValue.search"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          variant="primary"
                          type="submit"
                          class="rounded-0 rounded-end px-2"
                        >
                          <i class="bx bx-search bx-fw"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </form> -->
              </div>
              <!-- end col -->

              <div class="col-md-8 col-sm-8">
                <div class="d-flex justify-content-lg-end mb-lg-3">
                  <template>
                    <div class="me-2">
                      <b-button v-if="productBrandModule.access.create" @click="openCreateModal" variant="primary"><i class="uil uil-plus me-1"></i> Add Product
                        Brand</b-button>

                      <b-modal id="modalAddBusinessCategory" title="Add Product Brand" size="md" centered hide-footer
                        hide-header-close v-model="createModal">
                        <ValidationObserver v-slot="{ handleSubmit, reset }">
                          <b-form class="px-4 py-3" @submit.prevent="handleSubmit(createProdBrand)" @@reset.prevent="reset">
                            <div class="row">
                              <div class="col-md-12 mb-3">
                                <label class="form-label small fw-bold">Product Brand<span style="color: red">*</span></label>
                                <validation-provider name="Product Brand" rules="required" v-slot="validationContext">
                                  <b-form-input
                                    type="text"
                                    class="form-control"
                                    id="addcontact-name-input"
                                    v-model="productBrandItem.productBrandName" 
                                    placeholder="Enter Product Brand"
                                    :state="getValidationState(validationContext)"
                                  />
                                  <b-form-invalid-feedback>
                                    {{ validationContext.errors[0] }}
                                  </b-form-invalid-feedback>
                                </validation-provider>
                              </div>
                              <div class="col-md-12 mb-3">
                                <image-upload v-model="brandLogo" label="Product Brand Image" :isRequired="true" />
                              </div>
                              <div class="col-md-12 mb-3">
                                <label class="form-label small fw-bold">Brand Description<span style="color: red">*</span></label>
                                <validation-provider name="Brand Description" rules="required" v-slot="validationContext">
                                  <b-form-textarea 
                                      id="textarea" 
                                      placeholder="Enter brand description..." 
                                      rows="3"
                                      max-rows="6" 
                                      v-model="productBrandItem.productBrandDesc" 
                                      :state="getValidationState(validationContext)"
                                    >
                                  </b-form-textarea>
                                  <b-form-invalid-feedback>
                                    {{ validationContext.errors[0] }}
                                  </b-form-invalid-feedback>
                                </validation-provider>
                              </div>
                            </div>

                            <div class="text-end mt-3">
                              <b-button
                                variant="light"
                                class="w-sm"
                                type="button"
                                @click="leaveform()"
                                >Close</b-button
                              >
                              <b-button 
                                variant="primary" 
                                class="w-sm ms-2"
                                type="submit"
                                >Save</b-button
                              >
                            </div>
                          </b-form>
                        </ValidationObserver>
                      </b-modal>
                    </div>
                  </template>

                  <a class="btn btn-secondary" @click="refresh()">
                    <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp;&nbsp; Refresh
                  </a>
                </div>
              </div>
              <div class="d-flex flex-wrap mt-3 mb-3">
                <div class="me-3 ta-right">
                  <b-form-group description="Search keyword">
                    <div class="d-flex">
                      <b-form-select class="form-select rounded-0 rounded-start shadow-none"
                        v-model="lookupParams.field" :options="searchOptions"></b-form-select>
                      <b-form-input v-on:keyup.enter="onSearch" v-model="searchValue.keyword" class="rounded-0">
                      </b-form-input>
                    </div>
                  </b-form-group>
                </div>
                <div class="me-3 ta-right">
                  <b-form-group description="Order by">
                    <div class="d-flex">
                      <b-form-select class="form-select rounded-0 rounded-start shadow-none w-200px" v-model="pagination.sort"
                        :options="orderFieldOptions"></b-form-select>
                      <b-form-select class="form-select rounded-0 rounded-start shadow-none w-100px"
                        v-model="pagination.orderDesc" :options="sortOrderOptions"></b-form-select>
                    </div>
                  </b-form-group>
                </div>
                <div class="me-2">
                  <b-form-group label="">
                    <b-button variant="primary" type="button" @click="onSearch" class="px-2">
                      <i class='bx bx-search bx-fw'></i>Search
                    </b-button>
                  </b-form-group>
                </div>
                <div>
                  <b-form-group label="">
                    <b-button variant="primary" type="button" @click="onExport" class="px-2 btn btn-primary h-fit">
                      <i class='uil uil-export me-1'></i> Export
                    </b-button>
                  </b-form-group>
                </div>
              </div>

              <!-- end col -->
            </div>
            <!-- end row -->

            <!-- grid list business category -->

            <template>
              <div class="row">
                <product-brand-item v-for="(productBrand, index) in productBrands" v-bind:key="index"
                  v-bind:productBrand="productBrand" @edit="editProdBrand(productBrand)"
                  @delete="deleteProdBrand(productBrand)" />
              </div>
              <!-- end row -->
            </template>
            <div class="row g-0 text-center" v-if="brandTotalRows == 0">
              <span>No data to display.</span>
            </div>
            <div class="row g-0 text-center text-sm-start mt-3" v-if="brandTotalRows != 0 && brandTotalRows > 12">
              <!-- end col -->
              <div class="col-sm-12">
                <div class="row">
                  <div class="col">
                    <div class="form-group row pull-left">
                      <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                      <div class="col-sm-6">
                        <b-form-group label-for="display-record">
                          <b-form-select class="form-select shadow-none w-fit" id="display-record"
                            v-model="pagination.rows" :options="pageOptions" @change="populateProductBrands"></b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="
                        dataTables_paginate
                        paging_simple_numbers
                        float-end
                      ">
                      <!-- pagination -->
                      <b-pagination class="pagination-rounded" v-model="pagination.page" @input="populateProductBrands"
                        :total-rows="brandTotalRows" :per-page="pagination.rows"></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>

    <!-- all modal -->
    <!-- edit modal -->
    <b-modal id="modalEditBusinessCategory" title="Edit Product Brand" size="md" centered hide-footer hide-header-close
      v-model="editModal">
      <ValidationObserver v-slot="{ handleSubmit, reset }">
        <b-form class="px-4 py-3" @submit.prevent="handleSubmit(saveProdBrand)" @@reset.prevent="reset">
          <div class="row">
            <label v-if="!productBrandModule.access.update" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot update a product brand.</label>
            <div class="col-md-12 mb-3">
              <label class="form-label small fw-bold">Product Brand<span style="color: red">*</span></label>
              <validation-provider name="Product Brand" rules="required" v-slot="validationContext">
                <b-form-input
                  type="text"
                  class="form-control"
                  id="addcontact-name-input"
                  v-model="productBrandItem.productBrandName" 
                  placeholder="Enter Product Brand"
                  :state="getValidationState(validationContext)"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </div>
            <div class="col-md-12 mb-3">
              <image-upload v-model="brandLogo" :imageSrc="productBrandItem.productBrandImageSrc" label="Product Brand Image" :isRequired="true" />
            </div>
            <div class="col-md-12 mb-3">
              <label class="form-label small fw-bold">Brand Description<span style="color: red">*</span></label>
              <validation-provider name="Brand Description" rules="required" v-slot="validationContext">
                <b-form-textarea 
                    id="textarea" 
                    placeholder="Enter brand description..." 
                    rows="3"
                    max-rows="6" 
                    v-model="productBrandItem.productBrandDesc" 
                    :state="getValidationState(validationContext)"
                  >
                </b-form-textarea>
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </div>
          </div>

          <div class="text-end mt-3">
            <b-button
              variant="light"
              class="w-sm"
              type="button"
              @click="leaveform('edit')"
              >Close</b-button
            >
            <b-button :disabled="!productBrandModule.access.update"
              variant="primary" 
              class="w-sm ms-2"
              type="submit"
              >Save</b-button
            >
          </div>
        </b-form>
      </ValidationObserver>
    </b-modal>
    <!-- end edit modal -->
  </div>
</template>

<style>
.m-200px {
  min-width: 150px;
}

.w-100px {
  width: 100px;
}
</style>